import React from "react"
import { Tooltip } from "antd"
import {
  STATISTIC_TYPE,
  TABLE_OPERATION_TYPE,
} from "types/ReportingDashboard/elements.types"
import {
  XTAB_STATISTIC_OPTIONS,
  DTAB_STATISTIC_OPTIONS,
} from "./StatisticTypeSelectOptions"

interface BuilderStatsRowProps {
  operation: TABLE_OPERATION_TYPE
  selectedOperators: STATISTIC_TYPE[]
  onToggle: (op: STATISTIC_TYPE) => void
  /**
   * Statistics shown as on and not toggleable (significance testing needs
   * them; the script emitter adds them to the operators while it is on).
   */
  lockedOperators?: STATISTIC_TYPE[]
}

const EMPTY_LOCKED: STATISTIC_TYPE[] = []

export const LOCKED_STAT_REASON = "Needed for significance testing"

/**
 * Statistic pill toggles. Options swap based on XTAB / DTAB context.
 * Reads its option list from the sibling StatisticTypeSelectOptions. The
 * console Builder and the dashboard inspector both render this row, so
 * their statistic choices stay in lockstep.
 */
const BuilderStatsRow: React.FC<BuilderStatsRowProps> = ({
  operation,
  selectedOperators,
  onToggle,
  lockedOperators = EMPTY_LOCKED,
}) => {
  const options =
    operation === TABLE_OPERATION_TYPE.XTAB
      ? XTAB_STATISTIC_OPTIONS
      : DTAB_STATISTIC_OPTIONS

  return (
    <div className="qc-stats-row" role="group" aria-label="Statistics">
      {options.map((opt) => {
        const isLocked = lockedOperators.includes(opt.value)
        const isSelected = isLocked || selectedOperators.includes(opt.value)
        const pill = (
          <button
            key={opt.value}
            type="button"
            className="qc-stat-pill"
            data-selected={isSelected}
            data-locked={isLocked || undefined}
            aria-pressed={isSelected}
            aria-disabled={isLocked || undefined}
            onClick={isLocked ? undefined : () => onToggle(opt.value)}
          >
            {opt.label}
          </button>
        )
        return isLocked ? (
          <Tooltip key={opt.value} title={LOCKED_STAT_REASON} placement="top">
            {pill}
          </Tooltip>
        ) : (
          pill
        )
      })}
    </div>
  )
}

export default BuilderStatsRow
